module.exports = __webpack_public_path__ + "static/hp_team_kevin-2489df718e7fe456dfab190b00604da4.png";